import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ContactNote from 'types/ContactNote';
import { ContactNoteListState } from './stateTypes';

export const initialNoteState: ContactNoteListState = {
  displayDialog: 'default',
  shownNote: null,
  drawerOpen: false,
  selectedRow: undefined as string | undefined,
  filters: {},
  subjectSearch: '',
  paginationPage: 0,
  dateRange: [null, null],
  error: '',
  usedInBr: false,
  loading: false,
  toastMessage: { show: false, titleText: '', description: '', type: 'neutral' },
  filterSearch: null,
  selectedNotes: [],
};

/**
 * The reducer used for the partner list UI element state management.
 */
const contactNoteSlice = createSlice({
  name: 'CONTACT_NOTE_LIST',
  initialState: initialNoteState,
  reducers: {
    initNoteList: (_) => {
      return initialNoteState;
    },
    setShownNote: (state, action) => {
      return { ...state, shownNote: action.payload };
    },
    setFilterSearch: (state, action) => {
      return { ...state, filterSearch: action.payload };
    },
    setNoteDisplayDialog: (state, action) => {
      return { ...state, displayDialog: action.payload };
    },
    openNoteDrawer: (state) => {
      return { ...state, drawerOpen: true };
    },
    closeNoteDrawer: (state) => {
      return { ...state, drawerOpen: false };
    },
    toggleContactNoteDrawer: (state, action) => {
      return { ...state, drawerOpen: action.payload };
    },
    setSelectedCnRow: (state, action) => {
      return { ...state, selectedRow: action.payload };
    },
    setCnFilters: (state, action) => {
      return { ...state, filters: action.payload };
    },
    setCnSubjectSearch: (state, action) => {
      return { ...state, subjectSearch: action.payload };
    },
    setCnPagination: (state, action) => {
      return { ...state, paginationPage: action.payload };
    },
    setCnDateRange: (state, action) => {
      return { ...state, dateRange: action.payload };
    },
    setCnError: (state, action) => {
      return { ...state, error: action.payload };
    },
    setUsedInBr: (state, action: PayloadAction<boolean>) => {
      return { ...state, usedInBr: action.payload };
    },
    setToastMessage: (state, action) => {
      return { ...state, toastMessage: action.payload };
    },
    setLoadingStatus: (state, action: PayloadAction<boolean>) => {
      return { ...state, loading: action.payload };
    },
    setSelectedNotes: (state, action: PayloadAction<ContactNote[]>) => {
      return { ...state, selectedNotes: action.payload };
    },
  },
});

export const {
  initNoteList,
  setShownNote,
  setNoteDisplayDialog,
  openNoteDrawer,
  closeNoteDrawer,
  toggleContactNoteDrawer,
  setSelectedCnRow,
  setCnFilters,
  setCnSubjectSearch,
  setFilterSearch,
  setCnPagination,
  setCnDateRange,
  setCnError,
  setUsedInBr,
  setLoadingStatus,
  setToastMessage,
  setSelectedNotes,
} = contactNoteSlice.actions;
export default contactNoteSlice.reducer;
